import { render, staticRenderFns } from "./PopMessage.vue?vue&type=template&id=f1c56236"
import script from "./PopMessage.vue?vue&type=script&lang=js"
export * from "./PopMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports